import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
import { TropicalLeaf } from './botanical/TropicalLeaf';
import { Eucalyptus } from './botanical/Eucalyptus';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/9g9ftWJsteQG1r7DZ97kAX/portada_2_hogar_natural.png';
export function NewHero() {
  return <Section className="pt-16 md:pt-24 pb-20 bg-cream-warm relative overflow-hidden" data-id="element-143">
      <TropicalLeaf className="absolute -top-20 -left-20 w-96 h-96 text-moss opacity-10 blur-sm rotate-45 pointer-events-none" aria-hidden="true" data-id="element-144" />
      <Eucalyptus className="absolute top-40 -right-10 w-64 h-64 text-sage-deep opacity-15 blur-[2px] -rotate-12 pointer-events-none" aria-hidden="true" data-id="element-145" />

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-146">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-forest-deep leading-tight mb-6 text-balance" data-id="element-147">
          Aprendé exactamente qué hacer cuando aparecen tos, acidez, dolor o
          insomnio en tu hogar.
        </h1>

        <p className="text-lg md:text-xl text-forest/80 mb-8 leading-relaxed text-balance font-medium" data-id="element-148">
          La guía práctica para dejar de sentirte perdido cuando alguien en casa
          se siente mal, usando ingredientes cotidianos y soluciones naturales
          simples.
        </p>

        {/* Mockup cuadrado 1:1 */}
        <div className="relative mx-auto mb-8 w-full max-w-md" data-id="element-149">
          <div aria-hidden="true" className="absolute inset-0 bg-honey/20 blur-3xl rounded-full scale-90" data-id="element-150" />
          <div className="relative aspect-square w-full overflow-hidden rounded-2xl border border-honey/20 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.4),0_0_40px_-10px_rgba(212,162,76,0.3)] bg-forest-mist" data-id="element-151">
            <img src={PRODUCT_IMAGE} alt="Hogar Natural en Casa — 5 guías naturales en formato digital" className="w-full h-full object-cover" data-id="element-152" />
          </div>
        </div>

        <Button variant="primary" size="xl" href={CHECKOUT_URLS.superPack} className="bg-forest-deep hover:bg-forest text-white shadow-lg text-base sm:text-lg tracking-wide w-full sm:w-auto px-8 py-5" data-id="element-153">
          👉 QUIERO SABER QUÉ HACER EN CASA
        </Button>
      </div>
    </Section>;
}